module.exports = __webpack_public_path__ + "static/media/avatar_3.879ec4de.svg";